<div class="container">
  <div class="zaya-form-header text-left" i18n="label|Appointments belonging to a practitioner.@@labelAppointments">Appointments</div>
  <div class="row">
    <div class="col-sm-12 col-md-4" *ngFor="let booking of bookings">
      <app-practitioner-booking-item [booking]="booking" (completed)="bookingCompleted($event)"></app-practitioner-booking-item>
    </div>
  </div>
</div>

<app-modal-notification #confirmation></app-modal-notification>
